/**
 * @fileoverview GET handler for the "/apps/user_info/scheduled_merge_duplicate_users_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoScheduledMergeDuplicateUsersRules } from "./constants";
import type { AppsUserInfoScheduledMergeDuplicateUsersRulesResult } from "./types";
import { isAppsUserInfoScheduledMergeDuplicateUsersRulesResult } from "./validators";

export const getAppsUserInfoScheduledMergeDuplicateUsersRules = reactQueryFetcherAdapter(
  appsUserInfoScheduledMergeDuplicateUsersRules,
  (signal: AbortSignal): Promise<AppsUserInfoScheduledMergeDuplicateUsersRulesResult> => {
    return fetch("/apps/user_info/scheduled_merge_duplicate_users_rules", "GET", {}, { signal });
  },
  isAppsUserInfoScheduledMergeDuplicateUsersRulesResult
);
